import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {VisuallyHidden} from "@unibuddy/patron";

import {IntlNamespaces} from "../../../../translations/types";
import {
    INTL_ACCESSIBILITY_POLICY,
    INTL_OPENS_IN_A_NEW_WINDOW,
} from "../../../../translations/common";
import {ThemedLink} from "../../../../components/ThemedLink/ThemedLink";

export const AuthFooter = ({
    hasGloballyWrappedAccessibilityPolicyLink,
}: {
    hasGloballyWrappedAccessibilityPolicyLink: boolean;
}) => {
    const {t} = useTranslation(IntlNamespaces.COMMON);

    return (
        <React.Fragment>
            {!hasGloballyWrappedAccessibilityPolicyLink && (
                <ThemedLink to="https://unibuddy.com/accessibility-policy/" external>
                    {t(INTL_ACCESSIBILITY_POLICY.key, INTL_ACCESSIBILITY_POLICY.defaultValue)}
                    <VisuallyHidden>
                        {t(INTL_OPENS_IN_A_NEW_WINDOW.key, INTL_OPENS_IN_A_NEW_WINDOW.defaultValue)}
                    </VisuallyHidden>
                </ThemedLink>
            )}
        </React.Fragment>
    );
};
